/**
 * To get around backend option indexing being an issue
 * Sorts product options and their variation lists based on the variation_map
 * of the product. Operates in place on a product.
 */ import { _ as _type_of } from "@swc/helpers/_/_type_of";
export var sortOptionsAndVariations = function(product) {
    var _product_variation_map, _product_options, _product_options1;
    // To get around indexing being an issue on the BE
    var entries = (_product_variation_map = product.variation_map) === null || _product_variation_map === void 0 ? void 0 : _product_variation_map.entries;
    if (entries === undefined) {
        return;
    }
    (_product_options = product.options) === null || _product_options === void 0 ? void 0 : _product_options.forEach(function(option) {
        var _option_variations;
        (_option_variations = option.variations) === null || _option_variations === void 0 ? void 0 : _option_variations.sort(function(first, second) {
            return entries.findIndex(function(entry) {
                return entry.name === first.name;
            }) - entries.findIndex(function(entry) {
                return entry.name === second.name;
            });
        });
    });
    (_product_options1 = product.options) === null || _product_options1 === void 0 ? void 0 : _product_options1.sort(function(first, second) {
        var _loop = function(i) {
            var _entries_find;
            var firstVariation = first.variations[i];
            var secondVariation = second.variations[i];
            // This should never happen since we first sort the variations
            // and a valid option should have exactly one variation
            // for every variant type
            if ((firstVariation === null || firstVariation === void 0 ? void 0 : firstVariation.name) !== (secondVariation === null || secondVariation === void 0 ? void 0 : secondVariation.name)) {
                return {
                    v: 0
                };
            }
            var variantOrder = (_entries_find = entries.find(function(entry) {
                return entry.name === (firstVariation === null || firstVariation === void 0 ? void 0 : firstVariation.name);
            })) === null || _entries_find === void 0 ? void 0 : _entries_find.entry_values;
            // This should also never happen, if one variant has an ordering
            // then all should have an ordering
            if (variantOrder === undefined) {
                return "continue";
            }
            var orderValue = variantOrder.findIndex(function(entry) {
                return entry.value === (firstVariation === null || firstVariation === void 0 ? void 0 : firstVariation.value);
            }) - variantOrder.findIndex(function(entry) {
                return entry.value === (secondVariation === null || secondVariation === void 0 ? void 0 : secondVariation.value);
            });
            // Only want to return the value if it isn't 0, otherwise we move
            // on to the next variant to see if it can be the determining factor
            if (orderValue !== 0) {
                return {
                    v: orderValue
                };
            }
        };
        if (!first.variations || !second.variations || first.variations.length !== second.variations.length) {
            return 0;
        }
        for(var i = 0; i < (first.variations.length || 0); i++){
            var _ret = _loop(i);
            if (_type_of(_ret) === "object") return _ret.v;
        }
        return 0;
    });
};
